import styled from '@emotion/styled'
import { calcRem } from '../../../../../__styling'
import { CoralCommentCount } from '../../../../../coral/CoralCommentCount'

export const Comments = styled.div({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: 'inherit',
})

export const CommentsSpan = styled(CoralCommentCount)({
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    color: 'inherit',
})

interface IconWrapperProps {
    size?: number
}

export const StyledIconWrapper = styled('div')<IconWrapperProps>(
    ({ size }) => ({
        height: (size && calcRem(size)) || calcRem(16),
        width: (size && calcRem(size)) || calcRem(16),
        padding: calcRem(2),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: calcRem(4),
    }),
)
